import moment from 'moment-timezone'
import { parseExpression } from 'cron-parser'
import cronstrue from 'cronstrue'

// Job schedules are cron expressions evaluated in Chicago time by the API.
export const JOB_TIME_ZONE = 'America/Chicago'

// cron-parser is pinned to v4: v5 uses syntax webpack 4 (react-scripts 3) cannot parse.
const parse = (schedule, currentDate) => parseExpression(schedule, {
    currentDate,
    tz: JOB_TIME_ZONE,
})

// Most recent cron slot at or before `now`. prev() is strictly before its
// currentDate, hence the extra millisecond (same as the API's is-job-due).
const getLastSlot = (schedule, now) => parse(schedule, new Date(now.getTime() + 1)).prev().toDate()

const getNextSlot = (schedule, now) => parse(schedule, now).next().toDate()

// Plain-language description of a job's schedule, e.g. "At 06:00 PM".
export const describeSchedule = ({ schedule, rate, rateUnit } = {}) => {
    if (schedule) {
        try {
            return cronstrue.toString(schedule, { verbose: false })
        } catch (e) {
            return schedule
        }
    }
    if (rate && rateUnit) {
        return `Every ${rate} ${rateUnit} (legacy)`
    }
    return 'Manual only'
}

// Mirrors the API runner: a job is due when its most recent cron slot is later
// than lastRunDate. Otherwise it runs at the next slot after now. Jobs without
// a schedule fall back to the legacy rate/rateUnit interval, or never run.
// Returns { isManual, isDue, nextRun } where nextRun is a Date or null.
export const getNextRun = ({ schedule, rate, rateUnit, lastRunDate } = {}, now = new Date()) => {
    if (schedule) {
        try {
            if (!lastRunDate || new Date(lastRunDate) < getLastSlot(schedule, now)) {
                return { isManual: false, isDue: true, nextRun: null }
            }
            return { isManual: false, isDue: false, nextRun: getNextSlot(schedule, now) }
        } catch (e) {
            return { isManual: false, isDue: false, nextRun: null }
        }
    }
    if (rate && rateUnit) {
        if (!lastRunDate) {
            return { isManual: false, isDue: true, nextRun: null }
        }
        const nextRun = moment(lastRunDate).add(rate, rateUnit)
        return nextRun.isAfter(now)
            ? { isManual: false, isDue: false, nextRun: nextRun.toDate() }
            : { isManual: false, isDue: true, nextRun: null }
    }
    return { isManual: true, isDue: false, nextRun: null }
}

export const formatJobTime = date => moment(date).tz(JOB_TIME_ZONE).format('MM/DD/YYYY h:mm A z')
